<template>
  <v-navigation-drawer width="300px" id="app-drawer" app dark v-model="$store.state.showCoreDrawer">
    <template v-slot:img="attrs">
      <v-img v-bind="attrs" gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)" />
    </template>
    <v-list-item two-line>
      <v-list-item-avatar color="white">
        <v-img src="https://cdn.vuetifyjs.com/images/logos/v.png" height="34" contain />
      </v-list-item-avatar>
      <v-list-item-title class="title">
        DASHBOARD
      </v-list-item-title>
    </v-list-item>
    <v-divider class="mx-3 mb-3" />
    <v-list nav>
      <div />
      <v-list-item v-for="(link, i) in links" :key="i" :to="link.to" active-class="primary white--text">
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title v-text="link.text" />
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default {
  data: () => ({
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard'
      },
      {
        to: '/buildings',
        icon: 'mdi-office-building',
        text: 'Buildings'
      },
      {
        to: '/entrances',
        icon: 'mdi-door-open',
        text: 'Entrances'
      },
      {
        to: '/floors',
        icon: 'mdi-floor-plan',
        text: 'Floors'
      },
      {
        to: '/apartments',
        icon: 'mdi-floor-plan',
        text: 'Apartments'
      },
      {
        to: '/parkings',
        icon: 'mdi-floor-plan',
        text: 'Parkings'
      },
      {
        to: '/gallery',
        icon: 'mdi-folder-multiple-image',
        text: 'Gallery'
      },
      {
        to: '/translations',
        icon: 'mdi-translate',
        text: 'Translations'
      }

    ]
  }),
}
</script>
